import React, { HTMLAttributes, ReactNode, useRef } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  children: ReactNode
  className?: HTMLAttributes<HTMLDivElement>['className']
  disableClick?: boolean
}

export function Widget({ children, className }: Props) {
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <div
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_WIDGET}
      ref={ref}
      className={cn(
        'mask-image relative mx-auto flex h-screen flex-col overflow-hidden bg-white sm:h-[720px] sm:w-[384px] sm:rounded-lg short:h-screen short:w-full short:rounded-none',
        className
      )}
    >
      {children}
    </div>
  )
}
